import { useEffect, useRef } from 'react';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

// Only the transition into BLOCKED can happen purely from the background poll with no mutation
// on this page causing it; every other transition is already covered by that mutation's own
// success toast, so surfacing them here too would just duplicate it.
export function useOrderStatusChangeToast(status: string | undefined) {
  const { t } = useTranslation('order');
  const previousStatus = useRef(status);

  useEffect(() => {
    if (status === 'BLOCKED' && previousStatus.current !== 'BLOCKED') {
      toast(t('order.status_updated_toast'));
    }
    previousStatus.current = status;
  }, [status, t]);
}
